module.exports = __webpack_public_path__ + "img/header.2a8b1656.png";